"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "Academy___StyledSvg",
  componentId: "sc-1dk0ble-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

var Academy = function Academy(_ref) {
  var title = _ref.title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M38.523 233.674H62.37v25.882H38.522v-25.882zm399.656-107.192l-183.29-94.04c-6.34-3.256-16.722-3.256-23.061 0L37 132.401v79.392h25.79V146.63l51.595 28.507v89.592h.053c0 9.476.052 17.915.052 24.766-.052.21-.052.42-.105.63.053 0 .053-.026.105-.026v14.32c0 66.99 77.385 145.569 128.966 145.569 51.582 0 128.967-78.58 128.967-145.57 0-18.584.59-94.355.315-129.504l65.65-36.264c6.248-3.465 6.143-8.951-.21-12.206v.039zm-299.683 54.587c26.971-6.865 62.448-11.065 101.495-11.065 39.047 0 74.55 4.214 101.496 11.065v28.927c-26.893-6.917-62.344-11.182-101.496-11.182-39.152 0-74.524 4.265-101.495 11.182V181.07zM341.5 273.666c-.105 12.692-.158 23.047-.158 28.323 0 49.692-67.068 108.02-101.43 108.02-34.387 0-101.43-58.328-101.43-108.02v-18.296c22.234-8.899 40.32-28.468 49.77-53.694 22.09 23.257 68.684 39.322 122.772 39.322 10.552 0 20.645-.813 30.45-2.02v6.365h.026zm-139.558 11.773c-6.983 0-12.692 5.775-12.692 12.941 0 7.14 5.71 12.941 12.692 12.941 7.035 0 12.692-5.801 12.692-12.941 0-7.166-5.657-12.941-12.692-12.941zm76.125 0c-6.983 0-12.692 5.775-12.692 12.941 0 7.14 5.71 12.941 12.692 12.941 7.035 0 12.692-5.801 12.692-12.941 0-7.166-5.657-12.941-12.692-12.941z"
  }));
};

var _default = Academy;
exports["default"] = _default;